const types = {
  SET_REV: 'SET_REV',
  CLEAR_REV: 'CLEAR_REV',
  SET_AVAILABLE_OWNERS: 'SET_AVAILABLE_OWNERS',
  SET_AVAILABLE_COACHES: 'SET_AVAILABLE_COACHES',
  SET_AVAILABLE_COLLABORATORS: 'SET_AVAILABLE_COLLABORATORS',
  SET_REV_CHALLENGES: 'SET_REV_CHALLENGES',
}

export default types
